import KPICards  from '../Components/KPICards';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
} from 'recharts';
import { kpiData, trendData, platformUsageData, transactionStatusData } from '../Data/mockData';

const COLORS = ['#3b82f6', '#10b981', '#f59e0b', '#8b5cf6'];

export default function Executive() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      
      {/* KPI Summary Cards */}
      <div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
          Key Performance Indicators
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(4, 1fr)',
            gap: 16,
          }}
        >
          {kpiData.map((kpi, index) => (
            <KPICards
              key={index}
              label={kpi.label}
              value={kpi.value}
              trend={kpi.trend}
              bgColor={kpi.bgColor}
            />
          ))}
        </div>
      </div>

      {/* Platform Usage Snapshot */}
      <div>
        <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827', marginBottom: 16 }}>
          Platform Usage Snapshot
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 16,
          }}
        >
          {/* Pie Chart */}
          <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 16 }}>
              Module Distribution
            </h3>
            <ResponsiveContainer width="100%" height={250}>
              <PieChart>
                <Pie
                  data={platformUsageData}
                  cx="50%"
                  cy="50%"
                  innerRadius={60}
                  outerRadius={90}
                  paddingAngle={5}
                  dataKey="value"
                  label={(entry) => `${entry.name}: ${entry.value}%`}
                >
                  {platformUsageData.map((_, index) => (
                    <Cell key={index} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>

          {/* Bar Chart */}
          <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 16 }}>
              Module Activity
            </h3>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={transactionStatusData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="status" tick={{ fontSize: 12 }} />
                <YAxis tick={{ fontSize: 12 }} />
                <Tooltip />
                <Legend wrapperStyle={{ fontSize: 12 }} />
                <Bar dataKey="cards" fill="#3b82f6" name="Cards" />
                <Bar dataKey="expense" fill="#10b981" name="Expense" />
                <Bar dataKey="ap" fill="#f59e0b" name="AP" />
                <Bar dataKey="payments" fill="#8b5cf6" name="Payments" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          {/* Transaction Status */}
          <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
            <h3 style={{ fontSize: 14, fontWeight: 600, color: '#374151', marginBottom: 32 }}>
              Transaction Status
            </h3>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span style={{ fontSize: 14, color: '#4b5563' }}>Pending Transactions</span>
                  <span style={{ fontSize: 18, fontWeight: 700, color: '#f97316' }}>10,234</span>
                </div>
                <div style={{ width: '100%', background: '#f3f4f6', height: 8, borderRadius: 999 }}>
                  <div style={{ width: '25%', background: '#f97316', height: 8, borderRadius: 999 }} />
                </div>
              </div>

              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                  <span style={{ fontSize: 14, color: '#4b5563' }}>Completed Transactions</span>
                  <span style={{ fontSize: 18, fontWeight: 700, color: '#22c55e' }}>83,000</span>
                </div>
                <div style={{ width: '100%', background: '#f3f4f6', height: 8, borderRadius: 999 }}>
                  <div style={{ width: '75%', background: '#22c55e', height: 8, borderRadius: 999 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Trends */}
      <div style={{ background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb', padding: 24 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: '#111827' }}>
            Platform Trends
          </h2>
          <div style={{ display: 'flex', gap: 8 }}>
            <button style={{ padding: '4px 12px', fontSize: 14, background: '#ede9fe', color: '#6d28d9', borderRadius: 6 }}>
              Amount
            </button>
            <button style={{ padding: '4px 12px', fontSize: 14, background: '#f3f4f6', color: '#374151', borderRadius: 6 }}>
              Count
            </button>
          </div>
        </div>

        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={trendData}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="month" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Line type="monotone" dataKey="amount" stroke="#3b82f6" strokeWidth={2} name="Amount (AED)" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
